<template>
  <div id="app">
	  <transition name="page" mode="out-in">
	    <router-view/>
	  </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: left;
		color: #f8f8f8;
		margin: 0;
		padding: 0;
		backface-visibility: hidden;
	}

	html, body {
		background-color: #282828;
	}

	* {
		margin: 0;
		padding: 0;
	}

	/* Page enter & leave transition 
		transition: opacity 0.4s, transform 0.7s;
	*/
	.page-enter-active, .page-leave-active {
		transition: opacity 0.4s;
	}

/* old page scroll
	transform: TranslateY(-30%);

*/
	.page-enter, .page-leave-to {
		opacity: 0;
	}

	/* Menu items move transition */
	.transition-center {
		transition: all 0.2s;
		transform-origin: 50% 50%;
	}

	/* Fade transition */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.8s ease;
		transition-delay: 0.5s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	/* Fade-slow transition */
	.fadeslow-enter-active,
	.fadeslow-leave-active {
		transition: opacity 1.1s ease;
		transition-delay: 0.6s;
	}

	.fadeslow-enter,
	.fadeslow-leave-to {
		opacity: 0;
	}

	/* Fade-zoom transition */
	.fadezoom-enter-active,
	.fadezoom-leave-active {
		transition: opacity 0.8s ease, transform 1.0s ease;
	}

	.fadezoom-enter,
	.fadezoom-leave-to {
		opacity: 0;
		transform: Scale(1.5);
	}


</style>



// WEBPACK FOOTER //
// src/App.vue